// While a product, collection or any content image is still loading, its frame shows the
// green X logo, semi-transparent, with a light sweep across it. The photo fades in once loaded.
(() => {
  // thumbnails and colour swatches use ::after for their chosen-corners, so the loading shine (also ::after) must not touch them
  const SKIP = 'header, dialog#predictive-search [type="search"], .xo-cart-flyer, [data-xo-no-loader], [data-thumb], s-variant-picker label';

  const done = (img) => {
    const holder = img.__xoHolder;
    if (!holder) return;
    holder.classList.add("xo-img-done");
    setTimeout(() => holder.classList.remove("xo-img-loading", "xo-img-done"), 450);
    img.__xoHolder = null;
  };

  const prepare = (img) => {
    if (img.__xoSeen) return;
    img.__xoSeen = true;
    if (img.closest(SKIP)) return;
    if (img.complete && img.naturalWidth > 0) return; // already there: nothing to show
    const holder = img.parentElement;
    if (!holder) return;
    const box = holder.getBoundingClientRect();
    if (box.width && box.width < 48) return; // tiny icons / thumbnails in lines
    if (getComputedStyle(holder).position === 'static') holder.classList.add('xo-img-rel');
    holder.classList.add('xo-img-loading');
    img.__xoHolder = holder;
    img.addEventListener('load', () => done(img), { once: true });
    img.addEventListener('error', () => done(img), { once: true });
  };

  const scan = (root) => {
    if (root.tagName === 'IMG') prepare(root);
    root.querySelectorAll?.('img').forEach(prepare);
  };

  const start = () => {
    scan(document);
    new MutationObserver((records) => {
      records.forEach((r) => r.addedNodes.forEach((n) => { if (n.nodeType === 1) scan(n); }));
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
